import Icon from "components/icon";
import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledBaseStatus = styled.div`
  padding-bottom: 2rem;
`;

export const StyledStatus = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  ${fontQuicksand()};
`;

export const StyledSuccess = styled(Icon)`
  color: ${Colors.GREEN};
`;

export const StyledFailure = styled(Icon)`
  color: ${Colors.RED};
`;
